import { Outlet } from "react-router-dom";
import "./layouts.css";
import useWindowDimensions from "../hooks/useWindowDimensions";
import HeaderDefault from "../componentes/headerDefault/header";
const DefaultLayout = () => {
  const { height, width } = useWindowDimensions();

  return (
    <div
      className="rootDiv"
      style={{
        maxWidth: width,
        minWidth: width,
        maxHeight: height,
        minHeight: height,
      }}
    >
      <div className="main">
        <div className="content">
          <HeaderDefault />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;